<script setup lang="ts">
import { useGlobalSetupStore } from "@/utils/GlobalSetupStore";
import type { BookingFormData } from "../types/index";

const props = defineProps<{
  form: BookingFormData;
  selectedActivity: any;
  isQuickBooking?: boolean;
  isAdmin?: boolean;
  userId?: string;
}>()
const globalSetupStore = useGlobalSetupStore();
const { globalSetup } = storeToRefs(globalSetupStore);

const showTermsConditionsDialog = ref(false);

const handleTermsClick = () => {
  if(props.form.agreement){
    props.form.agreement = false
  } else {
    if(props.userId || props.isQuickBooking || !globalSetup.value?.generalTermsAndConditions || props.isAdmin){
      props.form.agreement = true
    } else {
      showTermsConditionsDialog.value = true;
    }
  }
};
</script>
<template>
  <div class="booking_stepper__explanation mb-6">
    Review and agree to the terms and conditions
  </div>
  <VCheckbox
    v-model="form.agreement"
    :rules="[form.agreement || 'You must accept the terms and conditions']"
    @click.prevent="handleTermsClick"
  >
    <template #label>
      <div class="booking_stepper__agreement-message">
        {{ selectedActivity.bookingAgreement }}
        <a
          class="text-primary"
          @click.stop.prevent="showTermsConditionsDialog = true"
          v-if="globalSetup.generalTermsAndConditions"
        >
          Terms and conditions.
        </a>
      </div>
    </template>
  </VCheckbox>
  <TermsAndConditionsDialog
    :model-value="showTermsConditionsDialog"
    :htmlContent="globalSetup.generalTermsAndConditions"
    @close="showTermsConditionsDialog = false"
    @accept="form.agreement = true"
    @decline="form.agreement = false; showTermsConditionsDialog = false"
  />
</template>
